/* tslint:disable */
/* eslint-disable */
/**
 * Jobs 24/7
 * Jobs 24/7
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: shraaliya0802@gmail.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AddSubcategoryRequest
 */
export interface AddSubcategoryRequest {
    /**
     * 
     * @type {string}
     * @memberof AddSubcategoryRequest
     */
    title?: string;
    /**
     * 
     * @type {number}
     * @memberof AddSubcategoryRequest
     */
    categoryId?: number;
}

/**
 * Check if a given object implements the AddSubcategoryRequest interface.
 */
export function instanceOfAddSubcategoryRequest(value: object): value is AddSubcategoryRequest {
    return true;
}

export function AddSubcategoryRequestFromJSON(json: any): AddSubcategoryRequest {
    return AddSubcategoryRequestFromJSONTyped(json, false);
}

export function AddSubcategoryRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): AddSubcategoryRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'title': json['title'] == null ? undefined : json['title'],
        'categoryId': json['categoryId'] == null ? undefined : json['categoryId'],
    };
}

  export function AddSubcategoryRequestToJSON(json: any): AddSubcategoryRequest {
      return AddSubcategoryRequestToJSONTyped(json, false);
  }

  export function AddSubcategoryRequestToJSONTyped(value?: AddSubcategoryRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'title': value['title'],
        'categoryId': value['categoryId'],
    };
}

